<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>工时统计</el-breadcrumb-item>
      <el-breadcrumb-item>个人工时统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="统计详情">
      </el-page-header>
      <div class="filters">
        时间筛选
        <div>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
          ></el-date-picker>

          <el-button
            class="ml-10"
            plain
            @click="exportData"
            :loading="downloadLoading"
            >导出</el-button
          >
        </div>
      </div>
      <el-table
        :data="results"
        border
        show-summary
        size="small"
        style="width: 100%"
        :summary-method="getSummaries"
      >
        <el-table-column prop="title" label="工序名称"></el-table-column>
        <el-table-column
          prop="task_count"
          align="center"
          sortable
          label="完成数量"
        >
        </el-table-column>
        <el-table-column prop="total" sortable align="center" label="共计工时">
        </el-table-column>
        <el-table-column prop="product_size_code" label="尺寸" align="center">
          <template slot-scope="scope">{{
            scope.row.product_size_name
          }}</template>
        </el-table-column>
        <el-table-column label="钻头序列号" min-width="200">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              type="info"
              effect="plain"
              class="ml-5"
              v-for="item in scope.row.products"
              :key="item.id"
              ><DrillLink :no="item.identifier"></DrillLink
            ></el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { manhourDetailStatistics } from '@/service/getData'
import flowEditor from '@/views/produce/flow/flow_editor'

export default {
  components: { flowEditor },
  data() {
    return {
      sizeCodes: {
        0: '-',
        1: '3~5寸',
        2: '5~8寸',
        3: '8~9寸',
        4: '9~12寸',
        5: '12~14寸',
        6: '14~18寸',
      },
      results: [],
      startTime: null,
      endTime: null,
      downloadLoading: false,
      dateRange: [this.$route.query.start_time, this.$route.query.end_time],
      userName: this.$route.query.user_name,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  watch: {
    dateRange(newv) {
      if (newv) {
        this.requestStatistics()
      }
    },
  },
  created() {
    this.initData()
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        } else if (index === 3 || index === 4) {
          sums[index] = '-'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index]
        } else {
          sums[index] = '-'
        }
      })

      return sums
    },
    initData() {
      this.requestStatistics()
    },
    async requestStatistics() {
      this.endTime = this.dateRange[1] + ' 23:59:59'
      this.startTime = this.dateRange[0] + ' 00:00:00'
      let data = {
        start_time: this.startTime,
        end_time: this.endTime,
        user_id: parseInt(this.$route.query.user_id),
      }
      let res = await manhourDetailStatistics(data)
      this.results = res.data.list
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          switch (j) {
            case 'serial_number':
              let s = []
              v.products.map((item) => {
                s.push(item.identifier)
              })
              return s.join(',')
            case 'product_size':
              return this.sizeCodes[v.product_size_code]
            default:
              return v[j]
          }
        })
      )
    },

    exportData() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          '工序名称',
          '完成数量',
          '共计工时',
          '尺寸',
          '钻头序列号',
        ]
        const filterVal = [
          'title',
          'task_count',
          'total',
          'product_size_name',
          'serial_number',
        ]
        const data = this.formatJson(filterVal, this.results)
        excel.export_json_to_excel({
          header: tHeader,
          // merges: d.merges,
          data,
          filename: `${this.userName}工时统计${this.dateRange.join('至')}`,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        })
        this.downloadLoading = false
      })
    },
  },
}
</script>

<style scoped>
.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.actions span {
  display: inline-block;
  margin-right: 1em;
  cursor: pointer;
}
</style>